import api from '@/api/shipin2/index.js';
import { store } from './store.js';

const pending = {
  notice: null,
  category: null,
  cate: null,
  config: null,
};

export async function ensureNotice() {
  if (store.noticeList.length) return store.noticeList;
  if (pending.notice) return pending.notice;
  pending.notice = api
    .queryAnnouncement()
    .then((res) => {
      store.setNoticeList(res.data);
      return store.noticeList;
    })
    .finally(() => {
      pending.notice = null;
    });
  return pending.notice;
}

export async function ensureCategory() {
  if (store.categoryList.length) return store.categoryList;
  if (pending.category) return pending.category;
  pending.category = api
    .queryClassificationList()
    .then((res) => {
      store.setCategoryList(res.data);
      return store.categoryList;
    })
    .finally(() => {
      pending.category = null;
    });
  return pending.category;
}

export async function ensureCateList() {
  if (store.cateList.length) return store.cateList;
  if (pending.cate) return pending.cate;
  pending.cate = api
    .getCateList()
    .then((res) => {
      store.setCateList(res.data);
      return store.cateList;
    })
    .finally(() => {
      pending.cate = null;
    });
  return pending.cate;
}

export async function ensureConfig() {
  // If we already fetched config with channel, return it
  if (store.configLoadedWithChannel) return store.config;
  if (pending.config) return pending.config;
  // Fetch config now (this call will include channel if interceptor is ready)
  pending.config = api
    .queryWebsiteConfiguration()
    .then((res) => {
      store.setConfig(res.data);
      store.markConfigWithChannel();
      return store.config;
    })
    .finally(() => {
      pending.config = null;
    });
  return pending.config;
}
